// Mock data for V Cosmetic Crafters website

export const heroImages = {
  primary: "https://images.unsplash.com/photo-1658387575528-88b316c42371",
  secondary: "https://images.unsplash.com/photo-1658387575558-b36be686c2cb"
};

export const rdImages = {
  testing: "https://images.unsplash.com/photo-1758685848544-625ddba413e4",
  botanical: "https://images.unsplash.com/photo-1761464644390-3e8615093ce7",
  quality: "https://images.unsplash.com/photo-1748261347902-451fb437e8fb"
};

export const productImages = {
  serum: "https://images.unsplash.com/photo-1764694187667-f28a05a52c0e",
  bottles: "https://images.unsplash.com/photo-1764694071462-db50e50a3925"
};

export const manufacturingImages = {
  cleanRoom: "https://images.unsplash.com/photo-1748349221526-33b51820b21e"
};

export const capabilities = [
  {
    id: 1,
    title: "Custom Formulation Development",
    description: "Tailored solutions from concept to commercial-ready formulas",
    icon: "FlaskConical"
  },
  {
    id: 2,
    title: "Active Ingredient Innovation",
    description: "Cutting-edge ingredient sourcing and compatibility studies",
    icon: "Atom"
  },
  {
    id: 3,
    title: "Stability & Performance Testing",
    description: "Comprehensive shelf-life and performance validation protocols",
    icon: "LineChart"
  },
  {
    id: 4,
    title: "Regulatory Support",
    description: "End-to-end compliance guidance for domestic and export markets",
    icon: "Shield"
  }
];

export const innovationAreas = [
  {
    id: 1,
    category: "Skincare",
    products: ["Anti-aging serums", "Moisturizers", "Cleansers", "Face masks", "Sun protection"],
    image: productImages.serum
  },
  {
    id: 2,
    category: "Haircare",
    products: ["Shampoos", "Conditioners", "Hair oils", "Scalp treatments", "Styling products"],
    image: productImages.bottles
  },
  {
    id: 3,
    category: "Personal Care",
    products: ["Body lotions", "Hand creams", "Deodorants", "Body washes", "Bath products"],
    image: rdImages.botanical
  },
  {
    id: 4,
    category: "Cosmeceuticals",
    products: ["Active-rich formulations", "Clinical-grade products", "Professional treatments"],
    image: rdImages.quality
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Idea & Consultation",
    description: "Understanding your vision, target market, and product goals",
    duration: "1-2 days"
  },
  {
    step: 2,
    title: "Lab Development",
    description: "Formulation design with active ingredient selection and compatibility testing",
    duration: "2-4 weeks"
  },
  {
    step: 3,
    title: "Prototype Creation",
    description: "Multiple iterations to perfect texture, efficacy, and sensory profile",
    duration: "1-2 weeks"
  },
  {
    step: 4,
    title: "Testing & Validation",
    description: "Stability studies, safety testing, and performance validation",
    duration: "4-8 weeks"
  },
  {
    step: 5,
    title: "Regulatory Compliance",
    description: "Documentation, label claims, and regulatory clearance support",
    duration: "2-3 weeks"
  },
  {
    step: 6,
    title: "Scale-up & Launch",
    description: "Pilot batch production and seamless commercialization",
    duration: "2-4 weeks"
  }
];

export const whyChooseUs = [
  {
    title: "Expert Scientific Team",
    description: "PhDs and formulation chemists with 15+ years in cosmetic R&D",
    metric: "15+ Years"
  },
  {
    title: "Rapid Development",
    description: "Industry-leading turnaround times without compromising quality",
    metric: "40% Faster"
  },
  {
    title: "Deep Customization",
    description: "Truly bespoke formulations tailored to your brand's unique needs",
    metric: "100% Custom"
  },
  {
    title: "IP Confidentiality",
    description: "Strict NDAs and proprietary formula protection protocols",
    metric: "Total Privacy"
  },
  {
    title: "Quality Assurance",
    description: "Rigorous testing standards exceeding industry requirements",
    metric: "ISO Certified"
  },
  {
    title: "End-to-End Support",
    description: "From concept to scale-up with continuous technical guidance",
    metric: "Full Service"
  }
];

export const regulatoryServices = [
  {
    title: "Ingredient Safety Assessment",
    description: "Comprehensive safety evaluations and toxicology reviews"
  },
  {
    title: "Label Claims Substantiation",
    description: "Scientific backing for product claims and marketing copy"
  },
  {
    title: "Domestic Compliance",
    description: "BIS, CDSCO, and India-specific regulatory requirements"
  },
  {
    title: "Export Compliance",
    description: "FDA, EU, ASEAN, and international market regulations"
  },
  {
    title: "Documentation Support",
    description: "CoA, MSDS, TDS, and all required product documentation"
  },
  {
    title: "Cosmetic Registration",
    description: "End-to-end registration support for target markets"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Founder, NaturGlow Skincare",
    content: "VCC transformed our idea into a market-ready formulation in just 8 weeks. Their scientific expertise and responsiveness are unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "Product Head, BeautyTech Co.",
    content: "The regulatory support alone saved us months. They understand both innovation and compliance perfectly.",
    rating: 5
  }
];
